export const OctagonAlert = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3115 0C13.8418 0.000113251 14.3506 0.210988 14.7256 0.585938L19.4141 5.27441C19.789 5.64938 19.9999 6.1582 20 6.68848V13.3115C19.9999 13.8418 19.789 14.3506 19.4141 14.7256L14.7256 19.4141C14.3506 19.789 13.8418 19.9999 13.3115 20H6.68848C6.1582 19.9999 5.64938 19.789 5.27441 19.4141L0.585938 14.7256C0.210988 14.3506 0.000113251 13.8418 0 13.3115V6.68848C0.000113251 6.1582 0.210988 5.64938 0.585938 5.27441L5.27441 0.585938C5.64938 0.210988 6.1582 0.000113251 6.68848 0H13.3115ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H10.0098C10.5621 15 11.0098 14.5523 11.0098 14C11.0098 13.4477 10.5621 13 10.0098 13H10ZM10 5C9.44772 5 9 5.44772 9 6V10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10V6C11 5.44772 10.5523 5 10 5Z"
      />
    </svg>
  )
}
